import React, { memo, useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { KatoSelect } from '@app/components';
import { SelectOption } from 'components/Select';
import { Kato } from '@app/models';

interface KatoModalProps {
  visible: boolean;
  onChange: (value: SelectOption<Kato>) => void;
  onClose?: () => void;
}

function KatoModal(props: KatoModalProps) {
  const { visible, onChange, onClose } = props;

  const onClickClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  return (
    <Dialog
      open={visible}
      onOpenChange={(open) => {
        if (!open) onClickClose();
      }}
    >
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Выберите регион</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <KatoSelect onChange={onChange} />
        </div>
        <DialogFooter>
          <Button onClick={onClickClose}>Выбрать</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default memo(KatoModal);
